// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"98d05b88","777":"af6bfc45","857":"1b6ce892"}[chunkId] + ".js";
};